
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, materialsModule, itemTypesModule, itemsModule } from '@/store/modules/store-accessor'
import _ from 'lodash'
import { TimeUtil } from '@/helpers/TimeUtil'
import { isDecimalNumber, isNumber } from "@/helpers/data";
import dayjs from 'dayjs';
import AssigneeCombo from '@/components/Combobox/AssigneeCombo.vue';
import { greekSearchFilter } from "@/helpers/data";

@Component({
  components: {
    AssigneeCombo,
  },
})
export default class EditMaterialModal extends Vue {
  @Prop()
  payload!: any;

  greekSearchFilter = greekSearchFilter;

  createdAtMenu = false;
  createAtTimeMenu = false;
  materialModel = {} as any;
  payloadMaterialModel = {} as any;
  isEditingMaterial = false;

  costRule:any =[(val: any) => val !== '' && val >= 0 || this.$i18n.t("cost_required"),
  (val: any) => val >= this.minActionAmount || this.$i18n.t("single_action_cost_rule")]

  descriptionRule= [(val: any) => (val == null || ((val?.text?.length <= 80) || val?.length <=80 )) || this.$i18n.t("client_form_description_length_rule")]

  notesRule= [
    (val: any) => {
      if(val != null) return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ]

  unitQuantityRule = [
    (val: any) => ((!!val || val == '') && val?.text?.length > 0) || this.$i18n.t("unitOptionRule"),
  ]

  itemUnitCostRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]

  itemUnitQuantityRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]


  itemUnitQuantityRules() {
  return [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
    (val: any) => {
      if (this.materialModel?.unit.enum_text === 'PIECES') {
        const valToString = String(val);
        if (valToString.includes('.') || valToString.includes(',')) {
          return this.$i18n.t("itemUnitPiecesDecimalWarning");
        }
      }
      return true;
    }
  ];
}

  itemUnitRule = [
    (val: any) => ((!!val || val == '') && val?.text?.length > 0) || this.$i18n.t("unitOptionRule"),
  ]

  async mounted() {
    this.payloadMaterialModel = _.cloneDeep(this.payload.material)
    await itemsModule.getItemsUnitsCombo();
    await commonModule.getItemsCombo();

    this.payloadMaterialModel.assignee_id = this.getAssigneeId(this.payload.material.assignee_id);
    this.payloadMaterialModel.created_at_date = dayjs(this.payload.material.created_at).format('YYYY-MM-DD');
    this.payloadMaterialModel.created_at_time = dayjs(this.payload.material.created_at).format('HH:mm');
    this.payloadMaterialModel.unit = this.findItemUnit(this.payload.material);
    this.payloadMaterialModel.unit_quantity = this.payload.material.unit_quantity ? this.payload.material.unit_quantity : '1';

    this.materialModel = _.cloneDeep(this.payloadMaterialModel);

    commonModule.initSnackbar({});
    await itemTypesModule.getItemTypesCombo();
  }


  updateAssignee(assignee: any) {
    if(assignee) {
      this.materialModel.assignee_id = assignee;
    }
  }

  async hideModal () {
    commonModule.hideModal();
  }

  get material() {
    return this.materialModel
  }

  get materialName () {
    return this.material.description != '' ? this.material.description : this.$i18n.t('material')
  }

  get itemTypesCombo () {
    return itemTypesModule.itemTypesCombo;
  }

  get minActionAmount() {
    return this.payload.material.cost - this.payload.job.balance
  }

  get editDisabled() {
    return _.isEqual(this.materialModel, this.payloadMaterialModel)
  }

  get assigneeIdCombo () {
    return commonModule.personnelCombo;
  }

  get isLoadingItems() {
    return itemsModule.loadingItemsCombo;
  }

  get itemsUnitsTypes() {
    return itemsModule.itemsUnitsCombo;
  }

  get inventoryItemsCombo () {
    return commonModule.inventoryItemsCombo;
  }

  getAssigneeId(name: string) {
    const combo: any = commonModule.personnelPartnersCombo;
    const foundItem = combo.find((item: any) => item.name === name);
    if(foundItem) {
      return { name: foundItem.name, id: foundItem.id };
    } else if(!foundItem && this.payload.material.assignee_id) {
      return { name: this.payload.material.assignee_id }
    } else {
      return ''
    }
  }

  async doEditMaterial () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.isEditingMaterial = true;
      let materialsObj = _.cloneDeep(this.materialModel);

      if (typeof materialsObj.description === 'object' && materialsObj.description != null) {
        materialsObj.description = materialsObj.description.text
      }
      await materialsModule.editMaterial(materialsObj);
      this.isEditingMaterial = false;
      this.hideModal();
    }
  }

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  onlyDecimalNumbers(evt: any) {
    isDecimalNumber(evt);
  }

  itemUnitNumberInputs(evt: Record<string,any>, item: Record<string, any>) {
    if(item.unit.decimals) {
      return isDecimalNumber(evt);
    }
    return isNumber(evt)
  }

  findItemUnit(unitType: Record<string, any>) {
    let combo: any = commonModule.inventoryItemsCombo;
    let foundType = undefined;
    if(unitType.inventory_item_id) {
      foundType = combo.find((obj: Record<string, any>) => obj.inventory_item_id === unitType.inventory_item_id);
    } else {
      foundType = combo.find((item: any) => item.text === unitType.description || item.text === unitType.text);
    }

    this.materialModel.inventory_item_id = unitType.inventory_item_id;

    if(foundType?.unit && foundType?.is_unit_based) {
      let unitCombo: any = itemsModule.itemsUnitsCombo;
      const foundUnitType = unitCombo.find((item: any) => item.enum_text == unitType.unit);

      this.materialModel.unit = { text: foundUnitType?.text, enum_text: foundUnitType?.enum_text, decimals: foundUnitType?.decimals, is_unit_based: foundType?.is_unit_based } as any;
      this.materialModel.unit_cost = null;
      this.material.unit_quantity = null;
      this.materialModel.is_unit_based = foundType?.is_unit_based;
      return { text: foundUnitType?.text, enum_text: foundUnitType?.enum_text, is_unit_based: foundType?.is_unit_based, decimals: foundUnitType?.decimals  } as any;
    } else {
      this.materialModel.unit = { text: '', enum_text: 'PIECES', decimals: false} as any;
      this.materialModel.is_unit_based = false;
      return { text: '', enum_text: 'PIECES',  decimals: false, is_unit_based: false } as any;
    }
  }

  calcItemUnitCost() {
    this.materialModel.cost = (this.materialModel.unit_cost * this.materialModel.unit_quantity).toFixed(2);
  }

  onlyNumbers(evt: any) {
      isNumber(evt);
    }

};
